import { Component, Input, OnInit, inject, input, output } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { MediaService, SvgViewboxDirective } from '@exl-ng/mulo-core';
import { ViewerFile } from '../../../shared/interfaces/viewer-file.interface';
import { TranslateModule } from '@ngx-translate/core';
import { ArcviewComponent, LoadingSlateComponent, DictionaryComponent, DictionaryItemComponent, DictionaryItemContentDirective, UrlTrustPipe, HtmlEscapePipe } from '@exl-ng/mulo-common';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton, MatButton, MatAnchor, MatIconAnchor } from '@angular/material/button';

import { MatDrawerContainer, MatDrawer, MatDrawerContent } from '@angular/material/sidenav';

@Component({
    selector: 'esp-arcview-container',
    templateUrl: './arcview-container.component.html',
    styleUrls: ['./arcview-container.component.scss'],
    imports: [
        MatDrawerContainer,
        MatDrawer,
        MatIconButton,
        MatIcon,
        SvgViewboxDirective,
        MatButton,
        MatDrawerContent,
        MatAnchor,
        RouterLink,
        MatIconAnchor,
        ArcviewComponent,
        LoadingSlateComponent,
        DictionaryComponent,
        DictionaryItemComponent,
        DictionaryItemContentDirective,
        UrlTrustPipe,
        TranslateModule,
        HtmlEscapePipe
    ]
})
export class ArcviewContainerComponent implements OnInit {
    route = inject(ActivatedRoute);
    media = inject(MediaService);

    readonly items = input<ViewerFile[]>(undefined);
    // TODO: Skipped for migration because:
    //  Your application code writes to the input. This prevents migration.
    @Input() currentIdx = 0;
    readonly currentIdxChange = output<number>();
    readonly isStandalone = input(false);
    readonly enableStandalone = input(true);
    readonly assetDetails = input<{
    label: string;
    value: string[];
}[]>(undefined);
    readonly openStandalone = output<number>();
    readonly currentRoute = input<ActivatedRoute>(undefined);
    readonly loading = input<boolean>(undefined);
    detailsOpen = false;
    contentsOpen = true;

    ngOnInit() {
        const currentRoute = this.currentRoute();
        if (currentRoute) {
            this.route = currentRoute;
        }
    }

    handleItemButtonClick(index) {
        index = Number.parseInt(index);
        this.currentIdx = index;
        this.currentIdxChange.emit(index);
    }

    handleDetailsToggle() {
        this.detailsOpen = !this.detailsOpen;
        setTimeout(() => window?.dispatchEvent(new Event('resize')), 400);
    }

    handleContentsToggle() {
        this.contentsOpen = !this.contentsOpen;
        setTimeout(() => window?.dispatchEvent(new Event('resize')), 400);
    }
}
